<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
            <i class="fa fa-exchange text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">CFOP</h4>
            <p class="text-muted mb-0 small">Naturezas de operação e códigos fiscais</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-input type="text" v-model="descricao" placeholder="Buscar por descrição..." class="border-0 bg-transparent" style="width: 200px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="tabela.isBusy" @click="pesquisar()">
                    <i class="fa fa-refresh mr-1"></i> ATUALIZAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Novo CFOP</span>
            </b-button>
        </div>
      </div>
      <!-- Tabela -->
      <b-row class="ml-0 mr-0 p-0">
        <b-col sm="12" class="p-0">
          <b-table
                  ref="tbl" 
                  id="table-transition-example"        
                  class="modern-premium-table"
                  :dark="isDark"
                  primary-key="CODIGO"
                  responsive  hover  small  show-empty
                  empty-text="Informe o filtro para ver os registros "
                  :busy.sync="tabela.isBusy" 
                  :sticky-header="stickyHeight"
                  :tbody-tr-class="rowClassSelecionado"
                  :items="itensFiltrados" 
                  :fields="tabela.campos"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="selecionarLinha"
                  @row-dblclicked="edit"
                  >
             <!-- Cabeçalho: ID -->
            <template #head(CODIGO)>
              <SetFilter
                label="CODIGO"
                v-model="filtros.CODIGO"
                :options="opcoes.CODIGO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <!-- Cabeçalho: Situação -->
            <template #head(NATUREZA)>
              <SetFilter
                label="NATUREZA"
                v-model="filtros.NATUREZA"
                :options="opcoes.NATUREZA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <!-- Cabeçalho: Situação -->
            <template #head(SITUACAO_TRADUZIDO)>
              <SetFilter
                label="Produto"
                v-model="filtros.SITUACAO_TRADUZIDO"
                :options="opcoes.SITUACAO_TRADUZIDO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #cell(SITUACAO_TRADUZIDO)="item">
              <b-badge pill :variant="colorirStatus(item.item.OP_SITUACAO)">{{item.item.SITUACAO_TRADUZIDO}}</b-badge>
            </template>      
            <template #cell(actions)="item">
              <div class="d-flex justify-content-end gap-1">
                <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                  <i class="fa fa-pencil"></i>
                </b-button>
                <b-button type="button" @click.stop.prevent="details(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                  <i class="fa fa-trash"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>  

    </div>
    
    <!-- Modal de Confirmação para Resultados Grandes -->
    <b-modal 
      ref="modalConfirmarResultadoGrande"
      id="modal-confirmar-resultado-grande"
      hide-header
      hide-footer
      centered
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      @shown="onModalShown"
      @hidden="onModalHidden"
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-warning">
          <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-exclamation-triangle text-dark"></i>
          </div>
          <div>
              <h5 class="mb-0 font-weight-bold text-dark">Muitos Registros</h5>
              <small class="text-dark opacity-75">A pesquisa retornou um volume alto de dados</small>
          </div>
          <b-button variant="link" class="ml-auto text-dark p-0 opacity-75" @click="$refs.modalConfirmarResultadoGrande.hide()">
              <i class="fa fa-times fa-lg"></i>
          </b-button>
      </div>

      <div class="p-4 bg-white text-center">
          <div class="mb-4">
              <h1 class="display-4 font-weight-bold text-warning">{{ resultadoPendenteCount }}</h1>
              <p class="text-muted">Registros encontrados</p>
          </div>
          
          <p class="text-dark mb-4">
              Deseja carregar todos os registros? Isso pode afetar o desempenho da aplicação.
          </p>

          <div class="d-flex justify-content-center gap-3">
              <b-button variant="outline-secondary" pill class="px-4" @click="cancelarCarregarResultadoGrande">
                  <i class="fa fa-ban mr-1"></i> CANCELAR
              </b-button>
              <b-button variant="warning" pill class="px-4 font-weight-bold" @click="confirmarCarregarResultadoGrande">
                  <i class="fa fa-check mr-1"></i> SIM, CARREGAR
              </b-button>
          </div>
          <div class="mt-3">
              <small class="text-muted">Pressione [ESC] para cancelar</small>
          </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import Tools from '@/tools/tools.js'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: {
    SetFilter
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'dados',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'CODIGO', type: 'number', label: 'ID' },
      { key: 'NATUREZA', type: 'string', label: 'Descrição' },
      { key: 'SITUACAO_TRADUZIDO', type: 'string', label: 'Situação' },
    ]
  })],

  data () {
    return {
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      tabela: {
        campos: [
          {
            key: "CODIGO",
            label: 'Id',
            sortable: true
          },
          {
            key: "NATUREZA",
            label: 'Descrição', 
            sortable: true 
          },
          {
            key: "SITUACAO_TRADUZIDO",
            label: 'Situação',
            class:'align-middle text-center',
            sortable: true 
          }
        ],
        sortBy: null,
        sortDesc: false,
        isLoading: false,
        status: '',
        isBusy: false,
      }
    }
  },
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    currentPage: {
      get () {
        return this.$store.getters['cfop/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("cfop/SET_PAGINA_ATUAL", Number(value) || 1);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['cfop/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('cfop/SET_PER_PAGE', Number(v) || 25)
      }
    },
    
    id: {
      get () {
        return this.$store.getters['cfop/ID']
      }, 
      set (value) {
        this.$store.commit("cfop/SET_ID", value);
      }
    },
    descricao: {
      get () {
        return this.$store.getters['cfop/NATUREZA']
      }, 
      set (value) {
        this.$store.commit("cfop/SET_NATUREZA", value);
      }
    },
    dados: {
      get () {
        return this.$store.getters['cfop/LISTA']
      }, 
      set (value) {
        this.$store.commit("cfop/SET_LISTA", value);
      }
    }
  },
  methods: {
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Listagem de CFOP',
        printedBy: window.localStorage.getItem('login') ?? '—',
        columns: this.tabela.campos,
        filename: 'cfop.html',
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.tabela.campos,
        filename: 'cfop.xlsx',
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.tabela.campos,
        filename: 'cfop.csv',
      });
    },
    limpar() {
      this.id = null
      this.descricao = null
      this.lista = []
    },
    selecionarLinha(item) {
      this.$store.commit("cfop/SET_REGISTRO_SELECIONADO_ID", item.CONTADOR)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['cfop/REGISTRO_SELECIONADO_ID']
      return item.CONTADOR === selId ? 'cec-row-selected' : ''
    },
    colorirStatus(valor) {
      if (valor === '0') return 'danger'
      else if (valor === '1') return 'success'
      else 'info'
    },
    details (item) {
      alert(JSON.stringify(item.CODIGO))
    },
    edit (item) {
      this.$store.commit("cfop/SET_REGISTRO_SELECIONADO_ID", item.CONTADOR)
      this.$router.push(`/cadastros/cfop/edit/${item.CONTADOR}`)
    },
    novo () {
      this.$router.push(`/cadastros/cfop/add`)
    },
    async pesquisar (ctx) {
      // Previne pesquisa se o modal de confirmação estiver aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      this.tabela.isBusy = true
      
      try {
        const resultado = await this.$store.dispatch('cfop/GET_LISTA')
        
        // Verifica se precisa de confirmação
        if (resultado.needsConfirmation) {
          // Fecha o aguardando antes de exibir o modal
          this.tabela.isBusy = false
          
          // Armazena os dados para uso posterior
          this.resultadoPendente = resultado.data
          this.resultadoPendenteCount = resultado.count
          
          // Exibe o modal de confirmação
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        // Resultado carregado normalmente
        this.status = true
      } catch(error) {
        this.status = false
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao pesquisar: ' + error.message)
      } finally {
        this.tabela.isBusy = false
      }
    },
    async confirmarCarregarResultadoGrande() {
      this.tabela.isBusy = true
      
      try {
        await this.$store.dispatch('cfop/GET_LISTA', { skipConfirmation: true })
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao carregar os registros: ' + err.message)
      } finally {
        this.tabela.isBusy = false
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Pesquisa cancelada. Refine os filtros para reduzir o resultado.')
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
      
      this.$nextTick(() => {
        const modalRef = this.$refs.modalConfirmarResultadoGrande
        if (modalRef && modalRef.$el) {
          const btnCancelarElement = modalRef.$el.querySelector('.modal-footer button.btn-secondary')
          if (btnCancelarElement) {
            btnCancelarElement.focus()
          }
        }
      })
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    }
  },
  watch: {
  },
  async created() {
    // Pesquisa apenas se a lista estiver vazia
    if (!this.lista || this.lista.length === 0) {
      await this.pesquisar()
    }
  }
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/views/cadastros/cfop/CfopListagem.vue